import React, { useEffect, useState, useRef } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import exportFromJSON from "export-from-json";

import { AvForm, AvField } from "availity-reactstrap-validation";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  Button,
  Label,
  Table,
  Spinner,
} from "reactstrap";

// Redux
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import cellEditFactory from "react-bootstrap-table2-editor";

import BootstrapTable from "react-bootstrap-table-next";
import "../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import "../../../../node_modules/react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";

import { postSubmitForm } from "../../../helpers/forms_helper";
import moment from "moment";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import preloader from "../../../helpers/preloader";
import showNotification from "../../../helpers/show_notification";
import SweetAlert from "react-bootstrap-sweetalert";
import printDiv from "../../../helpers/print_data";
const animatedComponents = makeAnimated();

const EquipmentAllOrders = (props) => {
  const [receiveBtnDisabled, setReceiveBtnDisabled] = useState(false);
  const { SearchBar } = Search;
  const [dateFrom, setDateFrom] = useState(() => {
    const currentDay = new Date();
    const firstDay = new Date(
      currentDay.getFullYear(),
      currentDay.getMonth(),
      1,
    );
    return firstDay;
  });
  const [dateTo, setDateTo] = useState();
  function formatDate(date) {
    if (!date) return;
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }

  useEffect(() => {
    const currentDay = new Date();
    const firstDay = new Date(
      currentDay.getFullYear(),
      currentDay.getMonth(),
      1,
    );
    setDateFrom(formatDate(firstDay));
    setDateTo(formatDate(currentDay));

    loadAllItems();
  }, []);

  // Edit Order

  const [remarks, setRemarks] = useState();
  const [quantity, setQuantity] = useState(0);
  const [rentalDays, setRentalDays] = useState(0);
  const [confirmDurationModal, setConfirmDuartionModal] = useState(false);
  const [is_rented, setIs_Rented] = useState(false);
  const [isUrgent, setIsUrgent] = useState(false);

  const [allOrders, setAllOrders] = useState([]);
  const [allOrdersFiltered, setAllOrdersFiltered] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("All");
  const [received, setRecieved] = useState([]);
  const [yetToReceive, setYetToReceive] = useState([]);
  const loadAllOrders = async () => {
    const days_diff = moment(dateTo).diff(dateFrom, "days");
    if (days_diff > 30) {
      setAllOrders([]);
      showNotification("Total number of days cannot be more than 31.", "Error");
      return false;
    } else if (days_diff < 0) {
      setAllOrders([]);
      showNotification("Invalid date range.", "Error");
      return false;
    }
    preloader(true);
    let date_from = moment(dateFrom).format("YYYY-MM-DD"),
      date_to = moment(dateTo).format("YYYY-MM-DD");
    // console.log(date_from, date_to);
    let url = process.env.REACT_APP_BASEURL + "equipmentorders/getforstore";
    const response = await postSubmitForm(url, { date_from, date_to });

    if (response && response.status === 1) {
      preloader(false);
      // let expandedRows = [];
      // response.data.map((item) => {
      //   if (item.status !== "Closed" && item.status !== "Rejected") {
      //     expandedRows.push(item._id);
      //   }
      // });
      setAllOrders(response.data);
      // setExpanded(expandedRows);
    } else {
      preloader(false);
      showNotification(response.message, "Error");
    }
  };

  useEffect(() => {
    if (selectedStatus) {
      if (selectedStatus === "All") {
        setAllOrdersFiltered(allOrders);
      } else {
        var data = JSON.parse(JSON.stringify(allOrders));
        setAllOrdersFiltered(
          data.filter((order) => order.status === selectedStatus),
        );
      }
    }
  }, [allOrders, selectedStatus]);

  const columns = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      dataField: "category",
      text: props.t("Category"),
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
    {
      dataField: "sub_category",
      text: props.t("Sub-Category"),
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
    {
      dataField: "name",
      text: props.t("Name"),
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      sort: true,
    },
    // {
    //   dataField: "available",
    //   text: props.t("Available"),
    //   formatter: (cell, row) => {
    //    return row.available+" "+row.unit
    //   },
    //   sort: true,
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "15%" };
    //   },
    // },
    {
      dataField: "quantity",
      text: props.t("Order Quantity"),
      formatter: (cell, row) => {
        return row.quantity + " " + row.unit;
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      dataField: "is_rented",
      text: props.t("Rented"),
      formatter: (cell, row) => {
        return row.is_rented ? "Yes" : "No";
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      dataField: "rental_days",
      text: props.t("Rental Days"),
      formatter: (cell, row) => {
        return row.is_rented ? row.rental_days : " ";
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      dataField: "date_to_return",
      text: props.t("Return Date"),
      formatter: (cell, row) => {
        return formatDate(row.date_to_return);
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
  ];

  const [selectedOrder, setSelectedOrder] = useState();
  const [editModal, setEditModal] = useState();
  const columns_external = [
    {
      dataField: "_id",
      hidden: true,
      csvExport: false,
    },
    {
      dataField: "_id",
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
      csvExport: false,
    },
    {
      dataField: "order_id",
      text: props.t("Order ID"),

      headerStyle: (colum, colIndex) => {
        return { width: "20%" };
      },

      style: { cursor: "pointer" },
    },
    {
      dataField: "remarks",
      text: props.t("Remarks"),

      headerStyle: (colum, colIndex) => {
        return { width: "20%" };
      },

      style: { cursor: "pointer" },
    },
    {
      text: props.t("Order Date"),
      dataField: "createdAt",
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      style: { cursor: "pointer" },
    },
    {
      dataField: "status",
      text: props.t("Status"),
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      style: { cursor: "pointer" },
    },
    {
      dataField: "admin_remarks",
      text: props.t("Eq. Store Remarks"),

      headerStyle: (colum, colIndex) => {
        return { width: "20%" };
      },

      style: { cursor: "pointer" },
    },
    {
      dataField: "",
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
      csvExport: false,
      formatter: (cell, row) => {
        if (row.status === "Placed") {
          return (
            <span className="text-primary">
              <i
                className="bx bxs-edit font-size-15"
                title="Click to Edit"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setReceiveBtnDisabled(false);
                  setEditModal(!editModal);
                  setSelectedOrder(row);
                  //setIsUrgent(row.is_urgent);
                  setEquipmentsForOrder(row.equipment_details);
                  setRemarks(row.remarks);
                }}
              ></i>
            </span>
          );
        } else {
          return (
            <span className="text-primary">
              <i
                className="mdi mdi-text-box-search font-size-15"
                title="Click to View Details"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setDetailsModal(!detailsModal);
                  setSelectedOrder(row);
                  // console.log(row);
                  let received_items = [];
                  let to_receive_items = [];
                  row.delivery_details.map((item) => {
                    if (item.is_received) {
                      received_items.push(item);
                    } else {
                      item.received_quantity = item.delivered_quantity;
                      to_receive_items.push(item);
                    }
                  });
                  // console.log(to_receive_items,"trec");
                  // console.log(received_items,"received Itrems");

                  setRecieved(received_items);
                  setYetToReceive(to_receive_items);
                }}
              ></i>
            </span>
          );
        }
      },
    },
  ];

  const handleOnExpand = (row, isExpand, rowIndex, e) => {
    if (isExpand) {
      setExpanded([...expanded, row._id]);
    } else {
      setExpanded(expanded.filter((x) => x !== row._id));
    }
  };
  const [expanded, setExpanded] = useState([]);
  const expandRow = {
    onlyOneExpanding: true,
    renderer: (row) => (
      <div>
        <BootstrapTable
          bootstrap4
          keyField="_id"
          data={row.equipment_details}
          columns={columns}
          noDataIndication="No data to display."
          striped
          hover
          condensed
        />
      </div>
    ),
    expanded: expanded,
    onExpand: handleOnExpand,
  };

  const rowStyle = (row, rowIndex) => {
    const style = { backgroundColor: "#fffbb8", fontWeight: "500" };
    if (row.status === "Closed") {
      style.backgroundColor = "#b8ffb9";
    } else if (row.status === "Placed") {
      style.backgroundColor = "#ffb8b8";
    } else if (row.status === "Rejected") {
      style.backgroundColor = "#f1b8ff";
    } else {
      style.backgroundColor = "#b8cdff";
    }
    return style;
  };

  const [detailsModal, setDetailsModal] = useState(false);
  const handleReceiveEquipmentOrder = async (e, v) => {
    try {
      setReceiveBtnDisabled(true);
      let equipmentorder_id = selectedOrder._id;
      let delivery_details = [];
      for (let i = 0; i < yetToReceive.length; i++) {
        delivery_details.push({
          _id: yetToReceive[i]._id,
          equipment_id: yetToReceive[i].equipment_id,
          received_quantity: yetToReceive[i].received_quantity,
          unit: yetToReceive[i].unit,
          cost_price: +yetToReceive[i].cost_price,
          batch: yetToReceive[i].batch,
          remarks: yetToReceive[i].remarks,
        });
      }
      const data_to_send = {
        equipmentorder_id,
        delivery_details,
      };

      let isNoRemarkUpdated = yetToReceive.some(
        (item) =>
          +item.received_quantity !== +item.delivered_quantity &&
          item.remarks === "",
      );
      // console.log(data_to_send,"pay");
      // return
      if (!isNoRemarkUpdated) {
        let url =
          process.env.REACT_APP_BASEURL + "equipmentorders/receive_by_store";
        const response = await postSubmitForm(url, data_to_send);

        if (response && response.status === 1) {
          loadAllOrders();

          setDetailsModal(!detailsModal);
          showNotification(response.message, "Success");
        } else {
          showNotification(response.message, "Error");
        }
      } else {
        setReceiveBtnDisabled(false);
        showNotification(
          "Enter remarks for all variances in received equipments.",
          "Warning",
        );
      }
    } catch (error) {
      // console.log(error);
    } finally {
      setReceiveBtnDisabled(false);
    }
  };

  const columns_received = [
    {
      dataField: "category",
      text: props.t("Category"),
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
    {
      dataField: "sub_category",
      text: props.t("Sub-Category"),
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
    {
      dataField: "name",
      text: props.t("Name"),
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      sort: true,
    },

    {
      text: props.t("Dispatch Time"),
      dataField: "date_of_transaction",
      formatter: (cell, row) => {
        return moment(row.date_of_transaction).format("DD/MM/YYYY HH:mm");
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      dataField: "delivered_quantity",
      text: props.t("Del. Qty."),
      formatter: (cell, row) => {
        return row.delivered_quantity + " " + row.unit;
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      dataField: "received_quantity",
      text: props.t("Rec. Qty."),
      formatter: (cell, row) => {
        return row.received_quantity + " " + row.unit;
      },

      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      text: props.t("Remarks"),
      dataField: "remarks",

      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
  ];

  const columns_yet_to_receive = [
    {
      dataField: "category",
      text: props.t("Category"),
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
      editable: false,
    },
    {
      dataField: "sub_category",
      text: props.t("Sub-Category"),
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
      editable: false,
    },
    {
      dataField: "name",
      text: props.t("Name"),
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
      sort: true,
      editable: false,
    },

    {
      text: props.t("Dispatch Time"),
      dataField: "date_of_transaction",
      formatter: (cell, row) => {
        return moment(row.date_of_transaction).format("DD/MM/YYYY HH:mm");
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      editable: false,
    },
    {
      dataField: "delivered_quantity",
      text: props.t("Del. Qty."),
      formatter: (cell, row) => {
        return (
          row.delivered_quantity && row.delivered_quantity + " " + row.unit
        );
      },
      formatExtraData: yetToReceive,
      editable: false,
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "13%" };
      },
    },

    {
      dataField: "received_quantity",
      text: props.t("Rec. Qty."),
      formatter: (cell, row) => {
        return row.received_quantity && row.received_quantity + " " + row.unit;
      },
      attrs: (cell, row, rowIndex, colIndex) => {
        return { title: "Click to Edit" };
      },
      style: (cell, row, rowIndex, colIndex) => {
        return { cursor: "pointer", background: "#ffffaa" };
      },
      sort: true,
      editable: false,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      dataField: "remarks",
      text: props.t("Remarks"),
      // formatter: (cell, row) => {
      //   return <>{row.sub_unit ? +row.received_quantity.in_sub_unit : 0}</>;
      // },
      editable: true,
      attrs: { title: "Click to Edit" },
      style: { cursor: "pointer", background: "#ffffaa" },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
  ];

  //#region  Update related functions

  const refForForm = useRef(null);
  const refSelectItem = useRef(null);

  const [allEquipments, setAllEquipments] = useState([]);
  const [selectedEquipment, setSelectedEquipment] = useState();
  const loadAllItems = async () => {
    let url = process.env.REACT_APP_BASEURL + "equipments/getall";
    const response = await postSubmitForm(url, {});
    if (response && response.status === 1) {
      const itemsLable = response.data.map((item) => ({
        ...item,
        label: `${item.category}-${item.name}(${item.brand})`,
        value: item._id,
      }));
      const SortedData = itemsLable.sort((a, b) =>
        a.name.localeCompare(b.name),
      );
      preloader(false);
      setAllEquipments(SortedData);
    } else {
      preloader(false);
      showNotification(response.message, "Error");
    }
  };

  const [equipmentsForOrder, setEquipmentsForOrder] = useState([]);
  const handleValidUpdate = async (e, v) => {
    try {
      const object = {
        id: selectedOrder._id,
        equipment_details: equipmentsForOrder,
        //is_urgent: isUrgent,
        remarks: v.remarks,
      };
      let url = process.env.REACT_APP_BASEURL + "equipmentorders/update";
      let response = await postSubmitForm(url, object);
      if (response.status === 1) {
        loadAllOrders();
        setEditModal(!editModal);
        setRemarks();
        setEquipmentsForOrder([]);
        setSelectedEquipment();
        refSelectItem.current.select.clearValue();
        refForForm.current.reset();
        showNotification(response.message, "Success");
        refForForm.current.reset();
      } else {
        showNotification(response.message, "Error");
      }
    } catch (error) {
      showNotification(error.message, "Error");
    }
  };

  function deleteFormatter(cell, row, rowIndex, extraData) {
    return (
      <>
        <span className="text-danger">
          <i
            className="bx bxs-trash font-size-15"
            title="Click to Delete"
            style={{ cursor: "pointer" }}
            onClick={() => {
              let arr = extraData.filter(
                (item) => item.equipment_id !== row.equipment_id,
              );
              setEquipmentsForOrder(arr);
            }}
          ></i>
        </span>
      </>
    );
  }

  const columns_items = [
    {
      dataField: "category",
      text: props.t("Category"),
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
    {
      dataField: "sub_category",
      text: props.t("Sub-Category"),
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
    {
      dataField: "name",
      text: props.t("Name"),
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      sort: true,
    },
    {
      dataField: "available",
      text: props.t("Available"),
      formatter: (cell, row) => {
        return row.available + " " + row.unit;
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      dataField: "quantity",
      text: props.t("Order Quantity"),
      formatter: (cell, row) => {
        return row.quantity + " " + row.unit;
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      dataField: "is_rented",
      text: props.t("Rented"),
      formatter: (cell, row) => {
        return row.is_rented ? "Yes" : "No";
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      dataField: "rental_days",
      text: props.t("Rental Days"),
      formatter: (cell, row) => {
        return row.is_rented ? row.rental_days : " ";
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      dataField: "",
      text: props.t("Remove"),
      formatter: deleteFormatter,
      formatExtraData: equipmentsForOrder,
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
  ];

  //#endregion Update related functions

  const handleDownload = async () => {
    const fileName = "all_equipment_orders";
    const exportType = "xls";

    let data_to_export = allOrders;

    if (data_to_export) {
      var data = [];
      JSON.parse(JSON.stringify(data_to_export)).forEach(function (v) {
        data.push({
          OrderID: v.order_id,
          Remarks: v.remarks,
          Date: moment(v.date_to_process).format("DD/MM/YYYY HH:mm"),
          IsUrgent: v.is_urgent ? "Yes" : "No",
          Status: v.status,
          CenterRemarks: v.admin_remarks,
        });
      });

      exportFromJSON({ data, fileName, exportType });
    }
  };

  const handleAddEquipment = async (e, v) => {
    var new_array_equip = JSON.parse(JSON.stringify(equipmentsForOrder));
    const existing_equipment = new_array_equip.filter(function (prod) {
      return prod.equipment_id === selectedEquipment._id;
    });

    if (existing_equipment.length > 0) {
      showNotification(
        props.t("This equipment is already added."),
        props.t("Warning"),
      );
    } else if (selectedEquipment) {
      let equipment_to_add = {};
      equipment_to_add.equipment_id = selectedEquipment?._id;
      equipment_to_add.unit = selectedEquipment.unit;
      equipment_to_add.name = selectedEquipment.name;
      if (rentalDays > 0) {
        equipment_to_add.is_rented = true;
        equipment_to_add.rental_days = +rentalDays;
      } else {
        equipment_to_add.is_rented = false;
      }
      equipment_to_add.category = selectedEquipment.category;
      equipment_to_add.sub_category = selectedEquipment.sub_category;
      equipment_to_add.brand = selectedEquipment.brand;
      equipment_to_add.available = selectedEquipment.available_in_unit;
      equipment_to_add.quantity = +quantity;
      setEquipmentsForOrder([...equipmentsForOrder, equipment_to_add]);
      setSelectedEquipment();
      setIs_Rented(false);
      setQuantity(0);
      setRentalDays(0);
      setConfirmDuartionModal(false);
      refSelectItem.current.select.clearValue();
    } else {
      showNotification(
        props.t("Select a product batch first."),
        props.t("Error"),
      );
    }
  };

  return (
    <React.Fragment>
      <Row>
        <Col lg={6}>
          <Card>
            <CardBody>
              <AvForm>
                <Row>
                  <Col lg={4}>
                    <AvField
                      name="dateFrom"
                      label={props.t("From Date")}
                      placeholder={props.t("Select")}
                      type="date"
                      value={dateFrom}
                      onChange={(e) => {
                        const selectedDate = e.target.value;
                        setDateFrom(formatDate(selectedDate));

                        const maxDate = moment(selectedDate)
                          .add(30, "days")
                          .format("YYYY-MM-DD");
                        const currentDate = moment().format("YYYY-MM-DD");

                        if (
                          moment(dateTo).isAfter(maxDate) ||
                          moment(dateTo).isAfter(currentDate)
                        ) {
                          setDateTo(
                            maxDate > currentDate ? currentDate : maxDate,
                          );
                        }
                      }}
                      max={moment().format("YYYY-MM-DD")}
                      errorMessage={props.t("Date cannot be empty.")}
                      validate={{ required: { value: true } }}
                    />
                  </Col>
                  <Col lg={4}>
                    <AvField
                      name="dateTo"
                      label={props.t("To Date")}
                      placeholder={props.t("Select")}
                      type="date"
                      value={dateTo}
                      onChange={(e) => {
                        const selectedDate = e.target.value;
                        setDateTo(formatDate(selectedDate));
                      }}
                      min={dateFrom}
                      max={
                        moment(dateFrom).add(30, "days").format("YYYY-MM-DD") >
                        moment().format("YYYY-MM-DD")
                          ? moment().format("YYYY-MM-DD")
                          : moment(dateFrom)
                              .add(30, "days")
                              .format("YYYY-MM-DD")
                      }
                      errorMessage={props.t("Date cannot be empty.")}
                      validate={{ required: { value: true } }}
                    />
                  </Col>
                  <Col lg={4}>
                    <Button
                      type="submit"
                      className="btn btn-md btn-success mt-4"
                      onClick={() => {
                        if (dateFrom && dateTo) {
                          loadAllOrders();
                        }
                      }}
                    >
                      <i className="mdi mdi-checkbox-marked-circle"></i>{" "}
                      {props.t("Check")}
                    </Button>
                  </Col>
                </Row>
              </AvForm>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col className="col-12">
          <Card>
            <CardBody>
              <Row className="mb-2">
                <Col sm="4">
                  <Button
                    type="submit"
                    className="btn btn-sm btn-secondary"
                    onClick={handleDownload}
                  >
                    <i className="mdi mdi-file-export"></i>{" "}
                    {props.t("Export CSV")}
                  </Button>
                  {"   "}
                  <Link
                    to="#"
                    onClick={() => {
                      printDiv("printDiv");
                    }}
                    className="btn btn-sm btn-success mr-2"
                  >
                    <i className="fa fa-print"></i> Print
                  </Link>
                  <div className="search-box mr-2 mb-2 d-inline-block">
                    <div className="position-relative"></div>
                  </div>
                </Col>
              </Row>
              <div id="printDiv">
                <CardTitle className="text-center">
                  {props.t("All Equipment Orders")}
                </CardTitle>

                <ToolkitProvider
                  keyField="_id"
                  data={allOrdersFiltered && allOrdersFiltered}
                  columns={columns_external}
                  noDataIndication={props.t("No data to display.")}
                  bootstrap4
                  search
                  exportCSV
                >
                  {(props) => (
                    <div>
                      <Row>
                        <Col lg={4}>
                          <SearchBar
                            {...props.searchProps}
                            style={{ width: "300px" }}
                          />
                        </Col>
                        <Col lg={5}></Col>
                        <Col lg={3} className="text-right">
                          <select
                            name="status"
                            className="form-control"
                            value={selectedStatus}
                            onChange={(e) => {
                              setSelectedStatus(e.target.value);
                            }}
                          >
                            <option value="All">All</option>
                            <option value="Placed">Placed</option>
                            <option value="Approved">Approved</option>
                            <option value="Dispatched">Dispatched</option>
                            <option value="Closed">Closed</option>
                            <option value="Rejected">Rejected</option>
                          </select>
                        </Col>
                      </Row>

                      <BootstrapTable
                        striped
                        hover
                        condensed
                        expandRow={expandRow}
                        rowStyle={rowStyle}
                        {...props.baseProps}
                      />
                    </div>
                  )}
                </ToolkitProvider>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
      {/* Edit Modal starts */}
      <Modal
        size="lg"
        isOpen={editModal}
        toggle={() => setEditModal(!editModal)}
        onClosed={() => setSelectedEquipment()}
      >
        <ModalHeader toggle={() => setEditModal(!editModal)}>
          {props.t("Update Order")}
        </ModalHeader>
        <ModalBody>
          {selectedOrder && (
            <>
              <Row>
                <Col lg={12}>
                  <Card>
                    <CardBody>
                      <AvForm
                        onValidSubmit={() => setIs_Rented(true)}
                        ref={refForForm}
                      >
                        <Row>
                          <Col lg={5}>
                            <Label>{props.t("Equipment")}</Label>
                            <Select
                              ref={refSelectItem}
                              value={selectedEquipment}
                              onChange={(selected) => {
                                setSelectedEquipment(selected);
                                refForForm.current.reset();
                              }}
                              options={allEquipments}
                              classNamePrefix="select2-selection"
                              components={animatedComponents}
                              required
                            />
                          </Col>

                          {selectedEquipment && (
                            <>
                              <Col lg={3}>
                                <Label>
                                  {props.t("Quantity")}{" "}
                                  {selectedEquipment
                                    ? " (in " + selectedEquipment.unit + ")"
                                    : ""}
                                </Label>

                                <AvField
                                  name="quantity"
                                  placeholder={props.t("Enter Quantity")}
                                  errorMessage="Quantity cannot be empty."
                                  type="text"
                                  onChange={(e) => setQuantity(e.target.value)}
                                  validate={{
                                    required: { value: true },
                                    pattern: {
                                      value: "^[0-9]+$",
                                      errorMessage: props.t(
                                        "Only numbers are allowed.",
                                      ),
                                    },
                                    max: {
                                      value:
                                        selectedEquipment &&
                                        selectedEquipment.available_in_unit,
                                      errorMessage:
                                        selectedEquipment &&
                                        props.t("Cannot order more than ") +
                                          selectedEquipment.available_in_unit +
                                          ".",
                                    },
                                    min: {
                                      value: 1,
                                      errorMessage:
                                        props.t("Cannot order less than 1  ") +
                                        selectedEquipment?.unit +
                                        ".",
                                    },
                                  }}
                                />
                              </Col>

                              <Col lg={3} className="mb-4">
                                <Label>&nbsp;</Label>
                                <br />
                                <Button
                                  type="submit"
                                  color="primary"
                                  className="btn btn-info waves-effect waves-light btn-sm"
                                >
                                  <i className="bx bx-add-to-queue"></i>{" "}
                                  {props.t("Add")}
                                </Button>
                              </Col>
                            </>
                          )}
                        </Row>
                        {/* <Button type="submit">Submit</Button> */}
                      </AvForm>
                      <hr />
                      {equipmentsForOrder && equipmentsForOrder.length > 0 && (
                        <>
                          <BootstrapTable
                            bootstrap4
                            keyField="_id"
                            data={equipmentsForOrder && equipmentsForOrder}
                            columns={columns_items}
                            noDataIndication="No data to display."
                            striped
                            hover
                            condensed
                          />
                          <AvForm onValidSubmit={handleValidUpdate}>
                            <Row>
                              <Col lg={6}>
                                <AvField
                                  name="remarks"
                                  value={remarks}
                                  onChange={(e) => {
                                    setRemarks(e.target.value);
                                  }}
                                  label={props.t("Remarks")}
                                  placeholder={props.t("Enter Remarks")}
                                  type="textarea"
                                />
                              </Col>
                              <Col lg={12}>
                                <div class="form-check">
                                  <input
                                    type="checkbox"
                                    name="is_urgent"
                                    className="is-untouched is-pristine av-valid form-check-input"
                                    checked={isUrgent}
                                    onChange={(e) => {
                                      if (e.target.checked) {
                                        setIsUrgent(true);
                                      } else {
                                        setIsUrgent(false);
                                      }
                                    }}
                                  />
                                  <label for="select_all">
                                    {" "}
                                    {props.t("This is an urgent order.")}
                                  </label>
                                </div>
                              </Col>
                              <Col lg={12}>
                                <hr />
                                <FormGroup className="mb-0 text-left">
                                  <div>
                                    <Button
                                      type="submit"
                                      color="primary"
                                      className="mr-1"
                                    >
                                      {props.t("Update Order")}
                                    </Button>{" "}
                                  </div>
                                </FormGroup>
                              </Col>
                            </Row>
                          </AvForm>
                        </>
                      )}
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </>
          )}
        </ModalBody>
      </Modal>

      {/* Edit Modal ends */}

      {/* Details Modal starts */}
      <Modal
        size="lg"
        isOpen={detailsModal}
        toggle={() => setDetailsModal(!detailsModal)}
        style={{ width: "925px", minWidth: "925px" }}
      >
        <ModalHeader toggle={() => setDetailsModal(!detailsModal)}>
          {props.t("Order Details") + " " + selectedOrder?.order_id}
        </ModalHeader>
        <ModalBody>
          <>
            <Row>
              <Col lg={12}>
                <Card>
                  <CardBody>
                    <Row>
                      {selectedOrder &&
                      yetToReceive &&
                      yetToReceive.length > 0 ? (
                        <>
                          <AvForm onValidSubmit={handleReceiveEquipmentOrder}>
                            <Col lg={12} md={12}>
                              <br />
                              <Label>
                                <b>{props.t("Dispatched Equipments")} </b>
                              </Label>
                            </Col>
                            <Col lg={12} className="mb-4">
                              <BootstrapTable
                                bootstrap4
                                keyField="_id"
                                key="_id"
                                data={yetToReceive}
                                columns={columns_yet_to_receive}
                                cellEdit={cellEditFactory({
                                  mode: "click",
                                  blurToSave: true,
                                })}
                                noDataIndication="No data to display."
                                striped
                                hover
                                condensed
                              />
                            </Col>
                            <Col lg={12} className="text-center">
                              <Label>&nbsp;</Label>
                              <br />
                              <Button
                                type="submit"
                                color="primary"
                                style={{ width: "150px" }}
                                disabled={receiveBtnDisabled}
                                className="btn btn-default waves-effect waves-light"
                              >
                                {receiveBtnDisabled ? (
                                  <Spinner size={"sm"} />
                                ) : (
                                  props.t("Receive")
                                )}
                              </Button>
                              <hr />
                            </Col>
                          </AvForm>
                        </>
                      ) : null}

                      <Col lg={12} md={12}>
                        <Label>Ordered Equipments</Label>
                      </Col>

                      <Col lg={12}>
                        <BootstrapTable
                          bootstrap4
                          keyField="_id"
                          data={
                            selectedOrder && selectedOrder.equipment_details
                          }
                          columns={columns}
                          noDataIndication="No data to display."
                          striped
                          hover
                          condensed
                        />
                        <hr />
                      </Col>

                      {selectedOrder && received && received.length > 0 ? (
                        <>
                          <Col lg={12} md={12}>
                            <br />
                            <Label>
                              <b>{props.t("Received Equipments")} </b>
                            </Label>
                          </Col>
                          <Col lg={12} className="mb-4">
                            <BootstrapTable
                              bootstrap4
                              keyField="_id"
                              key="_id"
                              data={received}
                              columns={columns_received}
                              noDataIndication="No data to display."
                              striped
                              hover
                              condensed
                            />
                            <hr />
                          </Col>
                        </>
                      ) : null}
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </>
        </ModalBody>
      </Modal>
      {/* Details Modal ends */}

      {is_rented && (
        <SweetAlert
          title={props.t("Is Equipment Temporary ?")}
          warning
          showCancel
          cancelBtnText={props.t("No")}
          confirmBtnText={props.t("Yes")}
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          onConfirm={() => {
            setIs_Rented(false);
            setConfirmDuartionModal(true);
          }}
          onCancel={() => {
            setIs_Rented(false);
            handleAddEquipment();
          }}
        >
          {/* {props.t(
                              "Once you reject this order, it cannot be revoked."
                            )} */}
        </SweetAlert>
      )}
      <Modal
        size="md"
        isOpen={confirmDurationModal}
        onClosed={() => {
          setIs_Rented(false);
          setQuantity(0);
          setRentalDays(0);
        }}
        toggle={() => {
          setConfirmDuartionModal(!confirmDurationModal);
          setIs_Rented(false);
          setQuantity(0);
          setRentalDays(0);
        }}
      >
        <ModalHeader
          toggle={() => setConfirmDuartionModal(!confirmDurationModal)}
        >
          {props.t("Enter Duartion in days")}
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <AvForm
                    onValidSubmit={(e, v) => {
                      handleAddEquipment();
                    }}
                  >
                    <Row>
                      <Col lg={12}>
                        <AvField
                          name="duration"
                          onChange={(e) => {
                            setRentalDays(e.target.value);
                          }}
                          label={props.t("Days")}
                          placeholder={props.t("Enter days")}
                          type="number"
                          validate={{
                            required: { value: true },
                          }}
                          errorMessage="Days cannot be empty."
                        />
                      </Col>
                      <Col lg={12}>
                        <FormGroup className="mb-0 text-center">
                          <div>
                            <Button
                              type="submit"
                              color="primary"
                              className="mr-1"
                            >
                              {props.t("Submit")}
                            </Button>
                          </div>
                        </FormGroup>
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

export default withRouter(
  connect(null, {})(withNamespaces()(EquipmentAllOrders)),
);
